const Tag = ({ children, cls }) => <span className={`inline-flex px-2 py-0.5 rounded-full text-[10px] font-semibold uppercase tracking-wider border ${cls}`}>{children}</span>;

function Col({ title, items, cls, testId }) {
  return (
    <div data-testid={testId}>
      <div className="text-[11px] uppercase tracking-wider text-slate-400 font-semibold mb-2">{title} <span className="text-slate-600">({items?.length || 0})</span></div>
      {items?.length ? <ul className="space-y-1 text-sm">{items.map((x, i) => <li key={i} className={cls}>· {x}</li>)}</ul> : <p className="text-xs text-slate-500 italic">—</p>}
    </div>
  );
}

export function DiagnosisSection({ biz }) {
  const d = biz?.diagnosis;
  const ev = biz?.evidence;
  if (!d && !ev) return null;
  return (
    <div className="space-y-4 mb-6" data-testid="brain-diagnosis">
      {ev && (
        <div className="nadia-card p-5" data-testid="brain-evidence">
          <div className="flex items-center gap-2 mb-3 flex-wrap">
            <div className="text-[11px] text-slate-400 uppercase tracking-wider font-semibold">Cosa Nadia sa davvero</div>
            <Tag cls="border-emerald-500/20 text-emerald-300 bg-emerald-500/10">Osservato</Tag>
            <Tag cls="border-amber-500/20 text-amber-300 bg-amber-500/10">Inferito</Tag>
            <Tag cls="border-white/10 text-slate-400">Mancante</Tag>
          </div>
          <div className="grid md:grid-cols-3 gap-4">
            <Col title="Dati osservati" items={ev.observed} cls="text-emerald-100" testId="evidence-observed" />
            <Col title="Inferenze (ipotesi)" items={ev.inferred} cls="text-amber-100" testId="evidence-inferred" />
            <Col title="Informazioni mancanti" items={ev.missing} cls="text-slate-400" testId="evidence-missing" />
          </div>
          {biz.questions_for_owner?.length > 0 && (
            <div className="mt-4 text-sm text-slate-200" data-testid="brain-questions">
              <div className="text-[11px] uppercase tracking-wider text-cyan-300 font-semibold mb-1">Domande che cambiano una decisione</div>
              <ul className="space-y-1">{biz.questions_for_owner.map((q, i) => <li key={i}>· {q}</li>)}</ul>
            </div>
          )}
        </div>
      )}
      {d && (
        <div className="nadia-card p-5" data-testid="brain-diagnosis-card">
          <div className="text-[11px] text-slate-400 uppercase tracking-wider font-semibold mb-1">Diagnosi commerciale</div>
          <p className="text-sm text-slate-300 mb-4">Perché oggi questa attività potrebbe non vendere quanto potrebbe (ipotesi da verificare, non certezze).</p>
          <div className="grid md:grid-cols-2 gap-4">
            <Col title="Opportunità" items={d.opportunities} cls="text-emerald-100" testId="diagnosis-opportunities" />
            <Col title="Problemi" items={d.problems} cls="text-rose-100" testId="diagnosis-problems" />
            <Col title="Ipotesi da testare" items={d.hypotheses_to_test} cls="text-slate-200" testId="diagnosis-hypotheses" />
            <div data-testid="diagnosis-actions">
              <div className="text-[11px] uppercase tracking-wider text-slate-400 font-semibold mb-2">Azioni prioritarie</div>
              <ol className="space-y-2 text-sm">{(d.priority_actions || []).map((a, i) => (
                <li key={i} className="text-slate-200"><span className="text-cyan-300 font-semibold mr-1">{i + 1}.</span><span className="text-white">{a.action}</span> — {a.why}{a.expected_impact && <span className="text-slate-400"> · {a.expected_impact}</span>}{a.requires_owner_input && <span className="text-amber-300"> · da confermare: {a.requires_owner_input}</span>}</li>
              ))}</ol>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
